export var AdditionalHeaders;
(function (AdditionalHeaders) {
    /**
     * Эти заголовки используется для сквозного логирования
     *
     * Формат мобайла:
     *  X-B3-TraceId
     *  X-B3-SpanId
     */
    AdditionalHeaders["TraceId"] = "x-b3-traceid";
    AdditionalHeaders["SpanId"] = "x-b3-spanid";
    AdditionalHeaders["ChannelId"] = "channel-id";
    /**
     * Приложение - источник запроса, например, newclick-dashboard-ui
     */
    AdditionalHeaders["OriginApplicationId"] = "AO-ORIGIN-APPLICATION-ID";
    /**
     * Идентификатор приложения в которое встроен вебвью с Альфа-Онлайн
     */
    AdditionalHeaders["HostWebviewApplicationId"] = "ApplicationId";
    AdditionalHeaders["Xsrf"] = "X-XSRF-TOKEN";
    AdditionalHeaders["Cus"] = "auth-user-id";
    AdditionalHeaders["ProxyRequestsFrom"] = "proxy-requests-from";
    AdditionalHeaders["Host"] = "host";
    /**
     * Заголовки для работы не-клиентов
     */
    AdditionalHeaders["UserRole"] = "mobile-user-role";
    AdditionalHeaders["IdentificationType"] = "identification-type";
    AdditionalHeaders["AuthPlasticId"] = "auth-plastic-id";
    AdditionalHeaders["CardOwnerId"] = "card-owner-id";
    /**
     * Заголовок для признака запроса из вебвью окружения (например для АМ-вебвью, значение будет 'AM')
     */
    AdditionalHeaders["Xwebview"] = "X-WEBVIEW";
    /**
     * Заголовок с версией приложения, который посылает вебвью из AM Android
     */
    AdditionalHeaders["AppVersion"] = "app-version";
    /**
     * Тип операционной системы для миддловых сервисов
     */
    AdditionalHeaders["Os"] = "OS";
    /**
     * Заголовки для работы с device-api
     */
    AdditionalHeaders["DeviceAppId"] = "DEVICE-APP-ID";
    AdditionalHeaders["AuthDeviceSecret"] = "auth-device-secret";
    /**
     * Заголовок для работы с часовым поясом
     */
    AdditionalHeaders["Timezone"] = "ZONE-OFFSET";
    /**
     * Заголовок для определения фича-ветки на миддл (не используется в production)
     */
    AdditionalHeaders["XfeatureName"] = "x-feature-name";
    AdditionalHeaders["PcUserId"] = "PAYCONTROL-USER-ID";
    /**
     * Заголовок для регистрации устройства в push-mfms-bridge
     */
    AdditionalHeaders["ApplicationCode"] = "APPLICATION-CODE";
    /**
     * Заголовок типа платформы
     */
    AdditionalHeaders["XscreenDimension"] = "X-SCREEN-DIMENSION";
    /**
     * Заголовок c хостом клиента
     */
    AdditionalHeaders["XforwardHost"] = "x-forwarded-host";
})(AdditionalHeaders || (AdditionalHeaders = {}));
